module.exports = __webpack_public_path__ + "static/img/news_top_07_1.1030f3ce.jpeg";